var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('scroll-up',{staticClass:"scroll-up-uniq",attrs:{"scroll-duration":2100,"scroll-y":650,"role":"application"},nativeOn:{"click":function($event){return _vm.focusTopOfPage.apply(null, arguments)}}})}
var staticRenderFns = []

export { render, staticRenderFns }